import { Box, styled, Typography } from '@mui/material';

export const HeaderRow = styled(Box)(({
  theme
}) => ({
  display: "grid",
  gridTemplateColumns: '40% 39% 20%',
  gap: theme.spacing(1),
  justifyContent: "left",
  alignItems: "center",
  mb: theme.spacing(2),
}));

export const CompanyType = styled(Typography)`
  margin-left: 20px;
`;

export const ButtonBox = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-end",
}));
